var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('StoreBanner',{attrs:{"imageList":this.config.banner_top.imageList}}),_c('StoreTitle'),_c('StoreList'),_c('StoreBanner3')],1)}
var staticRenderFns = []

export { render, staticRenderFns }